<template>
    <Row type="flex" class="c_box">
        <Cell class="c_left_box" :style="style">
            <slot name="left"/>
        </Cell>
        <Cell :flex="1" class="c_right_box" :style="style">
            <slot/>
        </Cell>
    </Row>
</template>

<script>
    export default {
        name: "BoxLayout",
        props: {
            fixedHeight: {
                type: Number,
                default: 145
            }
        },
        computed: {
            style() {
                return {height: `calc(100vh - ${this.fixedHeight}px)`};
            }
        },
    }
</script>

<style scoped>

</style>